import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { VaNicheSpecificDetails } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";

import styles from "../../styles";

interface Props {
  index: number;
  nichesToPickFrom: VaNicheSpecificDetails[];
  onChange: (e: CustomEvent, index: number) => void;
  niche?: VaNicheSpecificDetails;
}

const TemplateNicheQuestion = ({
  index,
  nichesToPickFrom,
  onChange,
  niche,
}: Props) => {
  return (
    <Grid container alignItems="center" sx={{ mb: 2 }}>
      <Typography variant="h6">Template {index + 1}</Typography>
      <Grid item xs={12}>
        <FormHelperText>What niche is this template for? *</FormHelperText>
        <FormControl fullWidth>
          <Select
            displayEmpty
            name="bento_category_id"
            sx={styles.textField}
            value={niche?.bento_category_id || ""}
            onChange={(e) => onChange(e, index)}
            required
          >
            <MenuItem value="">
              <em>Pick Niche</em>
            </MenuItem>
            {nichesToPickFrom.map((niche) => (
              <MenuItem
                key={niche.bento_category_id}
                value={niche.bento_category_id}
              >
                {niche.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box
          sx={{
            opacity: niche ? 1 : 0.5,
            pointerEvents: niche ? "auto" : "none",
          }}
        >
          <Grid item xs={12}>
            <FormHelperText>
              What are big brand names you've worked with in{" "}
              {niche?.name || "this niche"}? *
            </FormHelperText>
            <TextField
              sx={styles.textField}
              fullWidth
              name="past_brands"
              placeholder={"Type your answer here..."}
              onChange={(e) => onChange(e, index)}
              required
              value={niche?.past_brands || ""}
            />
            <FormHelperText>
              Share a top performing post (IG or TikTok link) in{" "}
              {niche?.name || "this niche"} (preferably it is on a brand page):
            </FormHelperText>
            <TextField
              sx={styles.textField}
              fullWidth
              name="top_performing_post_link"
              placeholder={"https://instagram.com/link"}
              onChange={(e) => onChange(e, index)}
              value={niche?.top_performing_post_link || ""}
            />

            <FormHelperText>
              Share 2-3 unique selling points about you in{" "}
              {niche?.name || "this niche"} *
            </FormHelperText>
            <TextField
              sx={styles.textField}
              fullWidth
              name="partnership_reason"
              placeholder={"Type your answer here..."}
              onChange={(e) => onChange(e, index)}
              required
              multiline
              rows={4}
              value={niche?.partnership_reason || ""}
            />
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default TemplateNicheQuestion;
